import { releasePages } from "@/mocks/manhwaData";

const badgeColor: Record<string, string> = {
  新作: "bg-primary-500",
  速报: "bg-accent-500",
  更新: "bg-secondary-500",
  推荐: "bg-secondary-500",
  完结: "bg-accent-500",
};

export default function LatestReleases() {
  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-flashlight-fill"></i>
              实时动态
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">最新韩漫发布页</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              汇总各韩漫站点的新作上线、榜单速报与完结补番动态，追更第一时间掌握。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {releasePages.map((item) => (
            <article
              key={item.id}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-background-50 ${
                  badgeColor[item.badge] ?? "bg-secondary-500"
                }`}
              >
                <i className="ri-article-line text-lg"></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap text-xs font-medium text-foreground-500">{item.site}</span>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] text-foreground-500">
                    {item.tag}
                  </span>
                  <span className="whitespace-nowrap text-[10px] text-foreground-400">{item.today}</span>
                </div>
                <h3 className="mt-1 truncate text-sm font-semibold text-foreground-900">{item.title}</h3>
              </div>
            </article>
          ))}

          <article className="flex items-center justify-center gap-3 rounded-lg border border-dashed border-primary-300 bg-primary-50 p-4 text-center">
            <p className="text-sm text-primary-700">
              想看更多更新动态？
              <a href="#submit" className="ml-1 font-medium underline underline-offset-2">
                前往提交收录
              </a>
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}